import React, { useEffect, useState } from 'react';
import {
  Button,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from '@material-ui/core';
import { useHistory, Link } from 'react-router-dom';
import { css } from '@emotion/core';
import { useRootStore } from '../../../stores/BridgeProvider';
import { WideBox, FlexDiv } from '../../styles/styles';
import { MenuList, filterOptions } from '../../util/ReactSelectOverrides';
import { CustomSelect } from '../../util/CustomCreatableSelect';
import Spinner from '../../util/Spinner';
import permissionCheck from '../../util/PermCheck';
import { COLORS } from '../../util/Colors';

const selectContainer = css`
  flex: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 10px;
`;

const SelectNewDealType = () => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [dealTemplates, setDealTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [value, setValue] = useState('template');
  const handleChange = event => {
    setValue(event.target.value);
  };

  const canManageTemplate = permissionCheck('DEALTEMP_M');

  useEffect(() => {
    const initialize = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/deal-templates`,
        );
        setDealTemplates(data);
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
    initialize();
  }, []);

  if (isLoading) return <Spinner />;

  const invalidDT = value !== 'template' || dealTemplates.length === 0;

  return (
    <FlexDiv>
      <WideBox showoverflow={1} style={{ maxWidth: '500px' }}>
        <Typography variant="h2" style={{ margin: '0 auto' }}>
          Create a New Deal
        </Typography>
        <FormControl
          style={{ margin: 'auto 0', width: '100%' }}
          component="fieldset"
        >
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={value}
            onChange={handleChange}
          >
            <FormControlLabel
              value="manual"
              control={<Radio color="primary" />}
              label={
                <div style={{ fontSize: '16px' }}>Create Deal Manually</div>
              }
            />
            <div
              style={{
                marginTop: '5%',
                display: 'flex',
                flexFlow: 'column nowrap',
              }}
            >
              <FormControlLabel
                value="template"
                control={<Radio color="primary" />}
                label={
                  <div style={{ fontSize: '16px' }}>
                    Create Deal From Template
                  </div>
                }
              />
              <CustomSelect
                isDisabled={invalidDT}
                isSearchable
                isClearable
                placeholder={!invalidDT && 'Select Deal Template'}
                components={{ MenuList }}
                options={dealTemplates}
                getOptionLabel={option => option.Name}
                getOptionValue={option => option}
                value={selectedTemplate}
                filterOption={filterOptions}
                onChange={val => setSelectedTemplate(val)}
              />
              {canManageTemplate && (
                <div style={{ textAlign: 'left' }}>
                  <Link
                    style={{ color: COLORS.blue, fontSize: '12px' }}
                    to="/deal-templates/new"
                  >
                    Create Template
                  </Link>
                </div>
              )}
            </div>
          </RadioGroup>
          <div css={selectContainer}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                size="large"
                disabled={value === 'template' && !selectedTemplate}
                style={{
                  margin: '5px 0px',
                }}
                onClick={() => {
                  if (value === 'manual') {
                    history.push({
                      pathname: '/deals/new-manual',
                    });
                  } else if (value === 'template') {
                    history.push({
                      pathname: '/new-deal-from-template',
                      state: { templateId: selectedTemplate.DealTemplateId },
                    });
                  }
                }}
              >
                Next
              </Button>
            </div>
            {/* <div>
              <Link to="/deals/new-manual">Or create a deal manually</Link>
            </div> */}
          </div>
        </FormControl>
      </WideBox>
    </FlexDiv>
  );
};

export default SelectNewDealType;
